// extracted by mini-css-extract-plugin
module.exports = {"store_grid":"StoreGrid_store_grid__aSoLi","store_grid_app":"StoreGrid_store_grid_app__gPeTA","spacer":"StoreGrid_spacer__N4Wf_"};